var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tooltip',{class:_vm.getTooltipClass(),attrs:{"position":_vm.getTooltipPosition(),"multilined":"","type":"is-dark"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.$t("Explanation.Tooltip")))])]},proxy:true}])},[_c('div',{ref:"launcherWrapper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }